import { apiFetch } from "./api";

export const browserPushSupported = () =>
  window.isSecureContext &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;
const preferenceKey = (scope: string) => `vzlive:browser-push:${scope}`;
export const browserPushOptedIn = (scope: string) =>
  localStorage.getItem(preferenceKey(scope)) === "true";

export function applicationServerKey(value: string): ArrayBuffer {
  const raw = atob(value.replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (char) => char.charCodeAt(0)).buffer;
}
export async function saveBrowserSubscription(subscription: PushSubscription) {
  await apiFetch("/api/admin/web-push", {
    method: "PUT",
    body: JSON.stringify({
      ...subscription.toJSON(),
      locale: navigator.language.startsWith("en") ? "en" : "de",
    }),
  });
}
export async function enableBrowserPush(scope: string, publicKey: string) {
  // Must be called directly from the user's click, before other async work (Safari).
  const permission = await Notification.requestPermission();
  if (permission !== "granted")
    throw new Error(
      "Bitte Mitteilungen für diese Website in den Browser-Einstellungen erlauben.",
    );
  let timer: ReturnType<typeof setTimeout> | undefined;
  const registration = await Promise.race([
    navigator.serviceWorker.ready,
    new Promise<never>((_, reject) => {
      timer = setTimeout(
        () =>
          reject(
            new Error("Push ist noch nicht bereit. Bitte die Seite neu laden."),
          ),
        10_000,
      );
    }),
  ]).finally(() => clearTimeout(timer));
  const subscription =
    (await registration.pushManager.getSubscription()) ??
    (await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: applicationServerKey(publicKey),
    }));
  await saveBrowserSubscription(subscription);
  localStorage.setItem(preferenceKey(scope), "true");
}
export async function removeBrowserPush(scope?: string) {
  if (!browserPushSupported()) return;
  const registration = await navigator.serviceWorker.getRegistration();
  const subscription = await registration?.pushManager.getSubscription();
  if (subscription) {
    await apiFetch("/api/admin/web-push", {
      method: "DELETE",
      body: JSON.stringify({ endpoint: subscription.endpoint }),
    });
    await subscription.unsubscribe();
  }
  if (scope) localStorage.setItem(preferenceKey(scope), "false");
}
